'use client'

const reviews = [
  { name: 'Sarah M.', text: 'Beautiful silk scarf — the colours are even more vibrant in person. Fast delivery to Sydney!', rating: 5 },
  { name: 'Emily K.', text: 'Love my new earrings! Great quality and unique designs you can\'t find elsewhere.', rating: 5 },
  { name: 'Rachel T.', text: 'The brocade jacket is stunning. Perfect for special occasions. Highly recommend!', rating: 5 },
  { name: 'Jessica L.', text: 'Gorgeous necklace, exactly as pictured. Will definitely be ordering more pieces.', rating: 4 },
  { name: 'Michelle W.', text: 'Amazing bracelet collection. Bought three as gifts and everyone loved them.', rating: 5 },
]

export function ModernReviews() {
  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold tracking-tight text-gray-900 mb-2">
            What Our Customers Say
          </h2>
          <p className="text-gray-500 text-sm">
            Rated 4.8/5 by 2,000+ happy customers
          </p>
        </div>

        <div className="flex gap-4 overflow-x-auto pb-4 snap-x snap-mandatory" style={{ scrollbarWidth: 'none' }}>
          {reviews.map((review, i) => (
            <div
              key={i}
              className="flex-shrink-0 w-[300px] md:w-[340px] snap-start bg-[#FAFAFA] rounded-xl p-6 border border-gray-100"
            >
              <div className="flex gap-0.5 mb-3">
                {Array.from({ length: review.rating }).map((_, j) => (
                  <span key={j} className="text-[#C8A860] text-sm">★</span>
                ))}
                {Array.from({ length: 5 - review.rating }).map((_, j) => (
                  <span key={j} className="text-gray-300 text-sm">★</span>
                ))}
              </div>
              <p className="text-gray-700 text-sm leading-relaxed mb-4">&ldquo;{review.text}&rdquo;</p>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-[#C8A860]/20 flex items-center justify-center text-[#C8A860] text-xs font-bold">
                  {review.name[0]}
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-900">{review.name}</p>
                  <p className="text-xs text-gray-500">Verified Buyer</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
